import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaySuccess() {
  const [status, setStatus] = useState("pending");
  const [msg, setMsg] = useState("Confirming payment with Stripe…");
  const attempts = useRef(0);
  const nav = useNavigate();

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setStatus("error"); setMsg("Missing session"); return; }
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); setMsg("Payment successful!"); return; }
        if (data.status === "expired") { setStatus("error"); setMsg("Session expired"); return; }
        attempts.current += 1;
        if (attempts.current >= 6) { setStatus("timeout"); setMsg("Still processing — check fees later"); return; }
        setTimeout(poll, 2000);
      } catch { setStatus("error"); setMsg("Could not verify payment"); }
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#FBF9F6]">
      <div className="nb-card p-10 max-w-md w-full text-center">
        {status==="pending" && <Loader2 size={48} className="mx-auto animate-spin"/>}
        {status==="paid" && <CheckCircle2 size={48} className="mx-auto text-emerald-600"/>}
        {(status==="error"||status==="timeout") && <XCircle size={48} className="mx-auto text-rose-600"/>}
        <h1 className="display text-2xl font-bold mt-4">{msg}</h1>
        <Link to="/student" className="nb-btn mt-6 inline-flex">Back to Dashboard</Link>
      </div>
    </div>
  );
}
